import styled from 'styled-components';

import { Link } from '../Link';

export const MobileView = styled.div`
  display: block;
  opacity: initial;

  @media (min-width: 1242px) {
    display: none;
  }

  nav ul li a {
    text-decoration: none;
    font-family: 'Lato', sans-serif;
    font-weight: 500;
    padding: 16px 0;
    font-family: 'Lato', sans-serif;
    line-height: 24px;
    letter-spacing: 0.51px;
    text-align: left;
    color: ${({ theme }) => theme.colors.gray};
  }
`;

export const Overflow = styled.div`
  position: fixed;
  left: 0;
  top: 84px;
  bottom: 0;
  width: calc(100vw - 360px);
  transform: translateX(calc(-100vw + 360px));
  z-index: 1;
  height: 100%;
  background: rgba(0, 0, 0, 0.32);
  transition: transform 450ms ease;
  @media (max-width: 768px) {
    width: 0;
    background: none;
    transform: translateX(0);
  }
`;

export const BurguerIcon = styled.button`
  top: 20px;
  right: 20px;
  position: absolute;
  width: 50px;
  height: 50px;
  z-index: 99999;
  outline: none;
  border: none;
  background: transparent;

  & > span {
    position: absolute;
    width: 30px;
    height: 3px;
    background-color: ${({ theme }) => theme.colors.green};
    top: 50%;
    right: 0;
    transition: 0.25s ease-in-out;
  }

  & > span::before {
    content: '';
    position: absolute;
    top: 1px;
    right: 0;
    background-color: inherit;
    width: 30px;
    height: 3px;
    transform: translateY(-12px);
    transition: 0.25s ease-in-out;
  }

  & > span::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    background-color: inherit;
    width: 30px;
    height: 3px;
    transform: translateY(10px);
    transition: 0.25s ease-in-out;
  }
`;

export const InputOpenSideMenu = styled.input`
  transition: all 0.3s;
  box-sizing: border-box;
  display: none;

  &:checked ~ nav,
  &:checked ~ ${Overflow} {
    transform: translateX(0);
    transition: transform 450ms ease-out;
  }

  &:checked ~ ${BurguerIcon} span {
    background-color: black;
    height: 0px;
  }

  &:checked ~ ${BurguerIcon} span::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    background-color: inherit;
    width: 30px;
    height: 3px;
    transform: rotate(135deg);
  }

  &:checked ~ ${BurguerIcon} span::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    background-color: inherit;
    width: 30px;
    height: 3px;
    transform: rotate(-135deg);
  }
`;

export const SideMenu = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  right: 0;
  top: 84px;
  bottom: 0;
  width: 360px;
  overflow-y: scroll;
  overflow-x: hidden;
  transform: translateX(360px);
  transition: transform 450ms ease;
  background-color: white;
  color: #333333;
  font-family: Helvetica, sans-serif;
  font-size: 1.2em;
  height: calc(100% - 84px);
  z-index: 9999;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.16);
  @media (max-width: 768px) {
    width: 100vw;
    transform: translateX(100vw);
  } ;
`;

export const RegisterButton = styled(Link)`
  color: white;
  z-index: 5000;
  width: 200px;
  min-width: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: auto;
  align-self: center;
  height: 3rem;
  background-color: ${({ theme }) => theme.colors.green};
  border-radius: 50px;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.26px;
  border: none;
  transition: all 0.4s;
  text-decoration: none;
  width: 150px;
`;

export const ButtonOutline = styled.a`
  background: none;
  color: ${({ theme }) => theme.colors.green};
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  height: 41px;
  letter-spacing: 0.025em;
  line-height: 21px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border: 1px solid ${({ theme }) => theme.colors.green};
  border-radius: 8px;
  padding: 10px 24px;
  margin: 3em 0 0 1.2rem;
`;

export const SideMenuInner = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0;
  font-size: 16px;
  margin-top: 1.3em;

  li:last-child,
  li:nth-child(4) {
    padding: 0;
  }

  li {
    text-decoration: none;
    border-style: none;
    color: ${({ theme }) => theme.colors.gray};
    font-weight: bold;
    font-family: 'Poppins', sans-serif;
    letter-spacing: 0.26px;
    line-height: 2;
    display: flex;
    align-items: center;
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    margin-left: 1em;
    gap: 8px;
  }
`;

export const ClientArea = styled.div`
  background: #eff4f8;
  padding: 20px 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ClientAreaWantBeClientItem = styled.a`
  margin-bottom: 1rem;
  text-decoration: none;
  font-family: 'Lato', sans-serif;
  color: ${({ color }) => color};
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 1rem;
  text-transform: uppercase;
`;
